import { render, staticRenderFns } from "./selectOption.vue?vue&type=template&id=c8b67dd8&scoped=true&"
import script from "./selectOption.vue?vue&type=script&lang=js&"
export * from "./selectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b67dd8",
  null
  
)

export default component.exports